<div class="container">
    <div class="d-flex flex-column justify-content-center align-items-center">
        <!-- <h1 style="text-align: center"> Oops!</h1> -->




        <div class="row align-items-center justify-content-center">

            <div class="col-12 mb-3">
                <h1 style="text-align: center;">Oops!</h1>


            </div>
            <div class="col-8">
                <mat-divider></mat-divider>

            </div>
            <div class="col-12 mt-4">
                <p class="mat-card-home-content" style="text-align: center;"> {{Etiquetas.PageNotFound.Text1}}</p>

            </div>
        </div>


    </div>
</div>